module.exports = __webpack_public_path__ + "static/media/previous-tests.910e62ce.png";